import React from 'react';
import { Box, Paper, Typography, Collapse } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function FlowDiagram({ steps, completedSteps, expandedStep, onStepClick, showDetails }) {
  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Protocol Steps
      </Typography>
      {steps.map((step, index) => (
        <Box key={index}>
          <Paper
            elevation={3}
            onClick={() => onStepClick && onStepClick(index)}
            sx={{
              p: 2,
              mb: 1,
              backgroundColor: completedSteps.includes(index) ? 'success.light' : 'background.paper',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              '&:hover': {
                transform: 'translateX(10px)',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {completedSteps.includes(index) && (
                <CheckCircleIcon color="success" />
              )}
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {step.title}
              </Typography>
            </Box>
            
            <Collapse in={completedSteps.includes(index) || expandedStep === index}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
                  {step.description}
                </Typography>
                {showDetails && step.content && (
                  <Box sx={{ pl: 2 }}>
                    {step.content.map((item, i) => (
                      <Typography key={i} variant="body2" sx={{ mb: 0.5 }}>
                        • {item}
                      </Typography>
                    ))}
                  </Box>
                )}
              </Box>
            </Collapse>
          </Paper>
          
          {index < steps.length - 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
              <ArrowDownwardIcon color="primary" />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default FlowDiagram;
